import { Action, SHOW_POSITION_DETAIL_MODAL } from 'actions';

interface State {
  positionId?: number;
}

export const ideaPositionDetails = (state: State = {}, action: Action): State => {
  switch (action.type) {
    case SHOW_POSITION_DETAIL_MODAL:
      if (action.payload.domain === 'IDEA') {
        return {
          ...state,
          positionId: action.payload.positionId,
        };
      }

      return state;

    default:
      return state;
  }
};
